import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PagesRoutes } from '../../../../routing/PagesRoutes';
import { platformCompaniesSelectors } from '../../../../state/ducks/platformCompanies/selectors';
import { platformUsersSelectors } from '../../../../state/ducks/platformUsers/selectors';
import { platformSuperAdminSelectors } from '../../../../state/ducks/platformSuperAdmin/selectors';
import { RootState } from '../../../../state/store/store';
import {
    PlatformHeaderWrapper,
    PlatformHubCard,
    PlatformHubCardHint,
    PlatformHubCardInner,
    PlatformHubCards,
    PlatformHubCardTitle,
    PlatformHubCardValue,
    PlatformPageSubtitle,
    PlatformPageTitle,
    PlatformPageWrapper
} from '../shared/platformPageStyles';

type Props = {
    companiesTotal: number;
    usersTotal: number;
    meEmail: string;
    fetchCompanies: () => void;
    fetchUsers: () => void;
};

const cards = [
    {
        to: PagesRoutes.PlatformCompanies,
        title: 'Organizations',
        hint: 'Create companies, edit subdomains, and open tenant links',
        statKey: 'companies' as const
    },
    {
        to: PagesRoutes.PlatformUsers,
        title: 'All users',
        hint: 'Find and manage users in any organization',
        statKey: 'users' as const
    },
    {
        to: PagesRoutes.PlatformAudit,
        title: 'Activity history',
        hint: 'Review changes made across the whole platform',
        statKey: null
    },
    {
        to: PagesRoutes.PlatformSuperAdmins,
        title: 'Super admin access',
        hint: 'Choose who can open this portal',
        statKey: null
    }
];

const PlatformHubPageConnected = ({ companiesTotal, usersTotal, meEmail, fetchCompanies, fetchUsers }: Props) => {
    useEffect(() => {
        fetchCompanies();
        fetchUsers();
    }, [fetchCompanies, fetchUsers]);

    return (
        <PlatformPageWrapper>
            <PlatformHeaderWrapper>
                <PlatformPageTitle>Platform home</PlatformPageTitle>
                <PlatformPageSubtitle>
                    Signed in as {meEmail}. Use the View as menu in the header to work inside any customer organization with the same screens you already use.
                </PlatformPageSubtitle>
                <PlatformHubCards>
                    {cards.map((card) => (
                        <PlatformHubCard key={card.to} to={card.to}>
                            <PlatformHubCardInner className="platform-hub-card-inner">
                                <PlatformHubCardTitle>{card.title}</PlatformHubCardTitle>
                                <PlatformHubCardValue>
                                    {card.statKey === 'companies'
                                        ? companiesTotal
                                        : card.statKey === 'users'
                                          ? usersTotal
                                          : 'Open'}
                                </PlatformHubCardValue>
                                <PlatformHubCardHint>{card.hint}</PlatformHubCardHint>
                            </PlatformHubCardInner>
                        </PlatformHubCard>
                    ))}
                </PlatformHubCards>
            </PlatformHeaderWrapper>
        </PlatformPageWrapper>
    );
};

const mapState = (state: RootState) => ({
    companiesTotal: platformCompaniesSelectors.total(state),
    usersTotal: platformUsersSelectors.total(state),
    meEmail: platformSuperAdminSelectors.me(state)?.email || state.user.userInfo.email
});

const mapDispatch = (dispatch: any) => ({
    fetchCompanies: () => dispatch.platformCompanies.fetchCompanies(),
    fetchUsers: () => dispatch.platformUsers.fetchUsers()
});

export default connect(mapState, mapDispatch)(PlatformHubPageConnected);
